import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useAvailableDormitories() {
  const [dormitories, setDormitories] = useState<IdName[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchDormitories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await DormitoryLegacyHttp.fetchAvailableDormitories();
      setDormitories(response.data?.payload ?? []);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { dormitories, fetchDormitories, loading, error };
}
